import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { favoritePlayerService } from 'general/js/services';
import gtm from 'general/js/gtm';

class FavoritePlayerButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFavourite: favoritePlayerService.isFavourite(props.playerId)
        };
    }

    onClickRoot = () => {
        const { playerId, trackCategory, trackAction, trackLabel } = this.props;
        const isFavourite = favoritePlayerService.isFavourite(playerId);

        if (isFavourite) {
            favoritePlayerService.remove(playerId);
        } else {
            favoritePlayerService.add(playerId);
        }

        this.setState({ isFavourite: !isFavourite });

        if (trackCategory && trackAction && trackLabel) {
            gtm.push(trackCategory, trackAction, trackLabel);
        }
    }

    render() {
        const { theme } = this.props;
        const stateCss = classNames({
            'is-active': this.state.isFavourite,
            'is-white': theme.isWhite,
            'is-dark': theme.isDark,
            'is-round': theme.isRound
        });

        return (
            <button
                className={`favourite-player-button ${stateCss}`}
                onClick={this.onClickRoot}
            >
                <svg className="icon" width="14" height="14" focusable="false">
                    <use xlinkHref="#icon-star"></use>
                </svg>
            </button>
        );
    }
}

FavoritePlayerButton.propTypes = {
    playerId: PropTypes.string,
    theme: PropTypes.object
};

export default FavoritePlayerButton;
